var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (r, e, t) => e in r ? i(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, m = (r, e) => {
  for (var t in e || (e = {}))
    s.call(e, t) && a(r, t, e[t]);
  if (o)
    for (var t of o(e))
      n.call(e, t) && a(r, t, e[t]);
  return r;
}, f = (r, e) => p(r, c(e));
import d, { forwardRef as l } from "react";
import w from "../lib/IconBase.mjs";
import H from "../defs/Heart.mjs";
const R = l((r, e) => /* @__PURE__ */ d.createElement(w, f(m({ ref: e }, r), { weights: H })));
R.displayName = "Heart";
export {
  R as Heart
};
